import { Component, Inject, OnInit, ViewContainerRef } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ErrorService } from '../../services/error.service';
import { OrderTemplateService } from '../../services/order-template.service';
import { SnackbarService } from '../../services/snackbar.service';

@Component({
	selector: 'app-order-template-modal',
	templateUrl: './order-template-modal.html'
})
export class OrderTemplateModalComponent implements OnInit {
	public form: UntypedFormGroup;
	public custId: number;
	public originalTemplateName: string;

	constructor(private _orderTemplateService: OrderTemplateService,
				private _vcRef: ViewContainerRef,
				private _snackbarService: SnackbarService,
				private _errorService: ErrorService,
				public dialogRef: MatDialogRef<OrderTemplateModalComponent>,
				@Inject(MAT_DIALOG_DATA) public data: any,
				private _formBuilder: UntypedFormBuilder) {
	}

	close() {
		this.dialogRef.close();
	}

	ngOnInit(): void {
		this.custId = this.data?.template?.custId;
		this.originalTemplateName = this.data?.template?.templateName;
		this.form = this._formBuilder.group({
			name: [this.originalTemplateName || '', [Validators.required, Validators.maxLength(50)]]
		});
	}

	saveTemplate(): void {
		if (this.form.valid) {
			this.data.template.templateName = this.form?.value?.name;
			this._orderTemplateService.createTemplate(this.data.template).subscribe(() => {
				this.dialogRef.close({success: true, templateName: this.form?.value?.name});
			}, (error) => {
				if (error.status !== 409) {
					this.dialogRef.close(error);
					this._errorService.error(null, 'saveTemplate failed', 'modal');
				}
			});
		} else {
			this._snackbarService.openSnackBar('Please fill out all required fields.', 'Close', 3000);
		}
	}
}
